const NamespacesNavigator = Vue.extend({
  props: {
    initialActiveId: {
      type: String,
      default: null
    }
  },

  data() {
    return {
      activeId: this.initialActiveId,
      namespaces: [],
      keyword: '',
      loading: true
    }
  },

  computed: {
    filteredNamespaces() {
      if (!this.keyword) return this.namespaces

      const keyword = this.keyword.toLowerCase()
      return this.namespaces.filter((ns) => {
        return (ns.name || '').toLowerCase().indexOf(keyword) >= 0 ||
          (ns.appid || '').toLowerCase().indexOf(keyword) >= 0
      })
    },

    isNewActive() {
      return this.activeId === 'new'
    },

    isAllActive() {
      return this.activeId === null || this.activeId === 'index'
    }
  },

  template: `
    <div class="sidebar-namespaces" data-has-namespace-navigator>
      <div class="input-control left-addon">
        <input type="text"
               class="controlled-input floated"
               v-model.trim="keyword"
               placeholder="搜索空间">
        <div class="addon">
          <i class="slp-search"></i>
        </div>
      </div>

      <div class="sidebar-content">
        <div class="list">
          <div class="list-title">操作</div>
          <div class="content">
            <div class="list-item"
                 :class="{ selected: isAllActive }"
                 @click="goToIndex">
              <i class="slp-list"></i>
              <span>所有空间</span>
            </div>
            <div class="list-item create-item"
                 :class="{ selected: isNewActive }"
                 @click="goToNew">
              <i class="slp-plus-circle"></i>
              <span>新建空间</span>
            </div>
          </div>
        </div>

        <div class="namespaces-list">
          <div class="list-head">
            <div class="list-title">空间</div>
          </div>
          <div class="list-body">
            <div v-if="loading" class="sidebar-tip">加载中...</div>
            <div v-else-if="filteredNamespaces.length === 0" class="sidebar-tip">没有空间</div>
            <div v-else
                 v-for="namespace in filteredNamespaces"
                 :key="namespace.id"
                 class="list-item namespace-item"
                 :class="{ selected: String(namespace.id) === String(activeId) }"
                 @click="goToShow(namespace)">
              <i class="slp-text-square"></i>
              <div class="namespace-item-content">
                <div class="namespace-item-name text-ellipsis">{{ namespace.name }}</div>
                <div class="namespace-item-meta">
                  <span class="meta-text">{{ namespace.organizations_count }} 组织</span>
                  <span class="meta-text">{{ namespace.users_count }} 人</span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  `,

  created() {
    this._fetchNamespaces()
  },

  methods: {
    _fetchNamespaces() {
      this.loading = true
      Skylark.Libs.Ajax.get('/admin/namespaces.json', {
        responseType: 'json',
        success: (data) => {
          this.namespaces = data || []
        },
        complete: () => {
          this.loading = false
        }
      })
    },

    goToShow(namespace) {
      const targetId = String(namespace.id)
      if (targetId === String(this.activeId)) return

      this.activeId = targetId
      Turbolinks.visit(`/admin/namespaces/${namespace.id}`)
    },

    goToNew() {
      if (this.activeId === 'new') return

      this.activeId = 'new'
      Turbolinks.visit('/admin/namespaces/new')
    },

    goToIndex() {
      if (this.isAllActive) return

      this.activeId = 'index'
      Turbolinks.visit('/admin/namespaces')
    },

    setActiveId(id) {
      this.activeId = id == null ? null : String(id)
    }
  }
})

export const generateNamespacesNavigator = {
  _generateNamespacesSidebarView(activeId) {
    const navigatorEl = DomMaster.find('[data-has-namespace-navigator]')

    if (navigatorEl.isPresent()) {
      this.sidebarVm = navigatorEl.node.__vue__
      this.sidebarVm.setActiveId(activeId)
    } else {
      this.sidebarVm = new NamespacesNavigator({
        el: Skylark.Helpers.Utilities.getOrCreateCleaningElementByIdForVue('namespaces-menu'),
        propsData: {
          initialActiveId: activeId == null ? null : String(activeId)
        }
      })
    }
  }
}

export default NamespacesNavigator
